import { Component, OnInit} from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-nutzungsbedingungen',
    templateUrl: './nutzungsbedingungen.component.html',
    styleUrls: ['./nutzungsbedingungen.component.scss']
})

export class NutzungsbedingungenComponent implements OnInit {

    constructor(
        private seoService: SeoService,
    ) { }

    ngOnInit() {
        this.seoService.set({
            title: 'Nutzungsbedingungen | Spieloguide',
            description: 'Nutzungsbedingungen von Spieloguide.',
            path: '/nutzungsbedingungen'
        });
    }
}
